import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { parseRoute } from './router'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App initialRoute={parseRoute(window.location.pathname)} />
  </React.StrictMode>
)
